<div class="mb-5 health-help-container">
    <div class="health-help-header-container">
        <div class="health-help-header-box">
            <div class="health-help-title">Need help with your health?*</div>
            <div class="health-help-subtitle">Here some useful links.</div>
        </div>
        <div class="health-help-notes-box">
            <div class="health-help-notes-text">*Nutrigenic does not claim that any of its offerings will treat, cure, or prevent any disease or health condition; always consult with a health professional when making any dietary changes/choices</div>
        </div>
    </div>
    <div class="health-help-faq-container">
        <div class="health-help-faq-container-column" *ngFor="let column of getColumns()">
            <div class="health-help-faq-container-faq" *ngFor="let article of column">
                <div class="health-help-faq-container-box">
                    <div class="health-help-faq-container-inner-box">
                        <div class="health-help-faq">{{article.title}}</div>
                        <div class="health-help-faq-box-link-source">{{article.source}}</div>
                    </div>
                    <div class="health-help-faq-box-link">Available at: <a href="{{article.url}}">{{article.urlText}}</a></div>
                </div>
            </div>
        </div>
    </div>
</div>
